import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderCyberSource } from '../../providers/payment/payment.cybersource'
import { PayNearMeBrand, StagedRiaBrand } from 'model/types/payment-method-type';
import { DirectBankBrand } from '../../model/types/payment-method-type';

/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */
export const regionValues = {
  region: Region.US,
  regionId: 105,
  defaultCountryFrom: 'US',
  defaultCountryFromOnfido: 'USA',
  defaultCountryCodeFrom: 1,
  defaultCurrencyFrom: 'USD',
  defaultAmountFrom: 100,
  defaultLanguageCulture: 'en-US',
  defaultLocation: {
    latitude: 34.037587,
    longitude: -118.249483
  },
  dateFormat: 'MM/DD/YYYY',    
  postalCodeRegex:`^(\\d{5}$|\\d{5}(-\\d{4})?)$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['en-US', 'es-US', 'vi-US'],
  regionalIp: '66.82.123.234',
  paymentProvider: <IPaymentProvider>new PaymentProviderCyberSource(),
  isPlaidEnabled: true,
  isBankAccountEnabled:true,
  useSecurityQuestions: true,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 0,
  directBankBrand: DirectBankBrand.None,
  distanceMetric: 'mi',
  acceptInternationalCards:false,
  stagedRiaBrand: 'Kroger',
  payNearMeBrand: 'SevenEleven',
  isEu: false,
  isEMEA: false,
  notShowMarketingPushAlert: true,
  useVeriff: false,
  googlepayAdyenPaymentNetworks: ["masterCard", "visa"],
  applepayAdyenPaymentNetworks: ["masterCard", "visa"],
  adyenMerchantCapability: ["debit", "3ds", "credit"],
  walletSettings:{
    isMerchantSupportEnable:false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  showNewHomePage: true,
  riaPrepaidCardBinNumber: "",
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:false,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  walletServices:[],
  isCountrySupportDecimal: true,
  autoEnableMarketingPreference: true,
  loginRootHomePage: "activity",
  adyenRegion: 'live-us'// https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};



// WEBPACK FOOTER //
// ./src/environment/region/US.ts